export default "__VITE_ASSET__Ue5JB64V__"